import React, { Component, } from 'react';
import './AgentInfo.css';
import userIcon from '../../../assets/userIcon.png';
// import serverUrl from '../../../serverUrl';
import { Dropdown } from 'react-bootstrap';
import { withTranslation } from "react-i18next";
import CompanyInfo from './CompanyInfo/CompanyInfo'
import AgentAlerts from './AgentAlerts/AgentAlerts'
import * as settings from '../../../settings'
import * as changeLogReq from '../../../axios/requests/changeLogReq'
import * as userReq from '../../../axios/requests/userReq'
import AlertContext from '../../../context/AlertModelContext/AlertModalContext'
import ChangeLogs from '../../UI/ChangeLog/ChangeLogs';

const serverUrl = process.env.NODE_ENV === 'production' ? settings.SERVER_URL_PROD : settings.SERVER_URL_DEV

export default withTranslation('common')(class AgentInfo extends Component {
    static contextType = AlertContext
    // constructor(props) {
    //     super(props);

    //     this.toggle = this.toggle.bind(this);
    //     this.onMouseEnter = this.onMouseEnter.bind(this);
    //     this.onMouseLeave = this.onMouseLeave.bind(this);
    //     this.state = {
    //         dropdownOpen: false
    //     };
    // }

    // toggle() {
    //     this.setState(prevState => ({
    //         dropdownOpen: !prevState.dropdownOpen
    //     }));
    // }

    // onMouseEnter() {
    //     this.setState({ dropdownOpen: true });
    // }

    // onMouseLeave() {
    //     this.setState({ dropdownOpen: false });
    // }

    onSeeUpdatesClickHandler = async () => {
        try {
            const allNotSeenChangeLogs = (await changeLogReq.getChangeLogs())?.data?.data
            if (allNotSeenChangeLogs) {
                this.context.showAlert(this.props.t('Updates'), <ChangeLogs changeLogList={allNotSeenChangeLogs} />, 'md')
            }
        } catch (err) {
            console.log(`popUpLastChangeLogs :: Error=${err}`)
        }
    }

    onOpenDigitalSignLinkClicked = async (isDigitalSignSupported) => {
        if (!isDigitalSignSupported || !this.props.companyDetails?.signature?.dashboardUrl) {
            return this.context.showAlert(this.props.t('fail'), this.props.t('Please contact system administrator to enable the feature'), 'sm');
        }
        else {
            window.open(`${this.props.companyDetails.signature.dashboardUrl}/company/template-forms`, "_blank")
        }
        // window.open(this.props.biUrl, "_blank")
    }

    render() {
        const isDigitalSignSupported = this.props.settings?.general?.isDigitalSignSupported
        const appAccess = this.props.companyDetails.appAccess
        return (

            <div className='row inChatTopRowRightAgenta'>
                <div className='col-12'>
                    <div className='AgentSectiona'>
                        <div className='agentContent'>
                            <div className='row'>
                                <div className='col-4 betterpadding settingsLeft' >
                                    <i className="fas fa-arrow-left fa-lg arrowIcon" onClick={() => this.props.changeWindowToShow(3)}></i>
                                    <Dropdown drop='left' className='costDropDown'>
                                        <Dropdown.Toggle className='settingsIcon'><i className="fas fa-bars fa-lg"></i></Dropdown.Toggle>
                                        <Dropdown.Menu className="CustomMenu">
                                            <Dropdown.Item eventKey="1" className='dropDownItem' onClick={() => this.props.onSettingsSelect(1)}>{this.props.t('New chat')}</Dropdown.Item>
                                            {this.props.device && <Dropdown.Item eventKey="7" className='dropDownItem' onClick={() => this.props.onSettingsSelect(7)}>{this.props.t('New call')}</Dropdown.Item>}
                                            {/* <Dropdown.Item eventKey="2" className='dropDownItem' onClick={() => this.props.onContactListBtnClicked('add', 'CONTACT')} >{this.props.t('Add New Contact')}</Dropdown.Item> */}
                                            <Dropdown.Item eventKey="2" className='dropDownItem' onClick={() => this.props.onContactListBtnClicked('add', 'NOACTIVITIYTAB')} >{this.props.t('Add New Contact')}</Dropdown.Item>
                                            {appAccess !== 'DIALER' && this.props.permissionType <= 3 && <Dropdown.Item eventKey="8" onClick={this.props.onShowMultipleMsgSendingClicked} className='dropDownItem'>{this.props.t('Multiple sending')}</Dropdown.Item>}
                                            {appAccess !== 'DIALER' && this.props.permissionType <= 3 && <Dropdown.Item eventKey="8" onClick={this.props.fetchFacebookFeedPosts} className='dropDownItem'>{this.props.t('sync facebook')}</Dropdown.Item>}
                                            <CompanyInfo
                                                appAccess={appAccess}
                                                companyDetails={this.props.companyDetails}
                                                listOfOnlineAgents={this.props.listOfOnlineAgents}
                                                device={this.props.device}
                                                companyAgents={this.props.companyAgents}
                                                permissionType={this.props.permissionType}
                                                facebook_userID={this.props.facebook_userID}
                                                onFaceBookUserIdChange={this.props.onFaceBookUserIdChange}
                                            />
                                            <Dropdown.Item eventKey="7.1" className='dropDownItemExit' onClick={this.onSeeUpdatesClickHandler}>{this.props.t('Updates')}</Dropdown.Item>
                                            {this.props.permissionType <= 3 ? <Dropdown.Item eventKey="8" onClick={this.props.onSettingsBtnClicked} className='dropDownItem'>{this.props.t('Settings')}</Dropdown.Item> : null}
                                            {this.props.permissionType <= 3 ? <Dropdown.Item eventKey="8.2" onClick={() => window.open(this.props.biUrl, "_blank")} className='dropDownItem'>{this.props.t('biUrl')}</Dropdown.Item> : null}
                                            {this.props.permissionType <= 3 ? <Dropdown.Item eventKey="8.3" onClick={() => this.onOpenDigitalSignLinkClicked(isDigitalSignSupported)} className='dropDownItem'>{this.props.t('signature')}</Dropdown.Item> : null}
                                            <Dropdown.Item eventKey="9" className='dropDownItemExit' onClick={this.props.onLogout}>{this.props.t('Logout')}</Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                    {appAccess !== 'DIALER' && <AgentAlerts onChatNotificationClicked={this.props.onChatNotificationClicked} />}

                                </div>
                                <div className='col-8 betterpadding settingsRight'>
                                    <div className='agentNameTitle'>
                                        <span className='agentNameSpan'>{this.props.name}</span>
                                        <img onClick={this.props.onAvatarClick} alt='cant load img' className='userIconAgenta' src={this.props.avatarImg ? serverUrl + `/users/${this.props.userId}/avatar` : userIcon} />
                                        {/* <img alt='cant load img' className='userIconAgenta' src={userIcon} /> */}
                                        {/* <div className='col-6' style={{padding:'0',display:'inline-block',cursor:'default'}}>{this.props.agentName}</div> */}

                                        {/* <div className='col-6' style={{padding:'0',display:'inline-block'}}><img onClick={this.props.onAvatarClick} alt='cant load img' className='userIconAgenta' src={this.props.avatarImg  ? serverUrl + `/users/${this.props.userId}/avatar` : userIcon } /></div> */}


                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
});

